/* eslint-disable camelcase */
import Vue from 'vue';
import Dialog from '../../../components/GenericDialog/GenericDialog';
import callRefFunc from '../../../utils/callRefFunc';
import transformFilterModelFromV0ToV1IfNotYet from '../../../utils/apiVersionConverters/filterModel/transformFilterModelFromV0ToV1IfNotYet';
import createRecords from '../../../utils/entityOperations/createRecords';
import Notify from 'quasar/src/plugins/Notify.js';;
import { getActingUser } from 'src/utils/actingUser';
export default Vue.extend({
    name: 'SaveViewDialog',
    components: { Dialog },
    data() {
        return {
            tableView: {
                all_users_can_use: false
            },
            genericTable_local: null
        };
    },
    computed: {
        disableSave() { return !this.tableView.name || this.tableView.name.length === 0; },
        generic_table_props_to_mix_in() {
            const { localFilterModel, paginationObject, localSortingModel } = (this.genericTable_local || {});
            const { lastResultOfUserInducedChangesToTableDisplay } = (this.genericTable_local || {});
            const result = {};
            if (localFilterModel)
                result.startingFilterModelProp = transformFilterModelFromV0ToV1IfNotYet(localFilterModel);
            if (paginationObject)
                result.initialRowsPerPageProp = paginationObject.page_size;
            if (localSortingModel)
                result.startingSortingModelProp = localSortingModel;
            if (lastResultOfUserInducedChangesToTableDisplay)
                result.requestedChangesToDataDisplayProp = lastResultOfUserInducedChangesToTableDisplay;
            return result;
        },
        dialogProps() {
            return {};
        }
    },
    methods: {
        save() {
            var _a, _b;
            const { generic_table_props_to_mix_in, closeDialog } = this;
            const newRecord = Object.assign(Object.assign({}, this.tableView), { generic_table_props_to_mix_in, applicable_to_table_ids: [String((_b = (_a = this.genericTable_local) === null || _a === void 0 ? void 0 : _a._props) === null || _b === void 0 ? void 0 : _b.tableIdProp)], scope_user_ids: [getActingUser().id] });
            createRecords('meta.table_views', [newRecord])
                .then(() => {
                Notify.create({
                    message: 'View saved',
                    color: 'positive',
                    icon: 'check'
                });
            })
                .finally(closeDialog);
        },
        closeDialog() { callRefFunc(this, 'dialogComponent', 'close'); },
        close() { this.closeDialog(); },
        openDialog() { callRefFunc(this, 'dialogComponent', 'open'); },
        open(genericTable) {
            this.tableView = Object.assign(Object.assign({}, this.tableView), { name: 'New view' });
            this.genericTable_local = Object.assign({}, genericTable);
            this.openDialog();
            this.$nextTick(() => {
                callRefFunc(this, 'nameInput', 'select');
            });
        }
    }
});
